<template>
    <el-dialog
    title="提示"
    :visible="value"
    width="400px"
    custom-class="code-dialog"
    :append-to-body="true"
    center
    @open="open"
    @close="close">
    <el-form class="code-form" :model="codeForm" :rules="codeRules" ref="codeForm" label-width="0px">
        <el-form-item prop="code">
            <el-input class="input-img-code-padding" v-model="codeForm.code" :maxlength="6" size="large" placeholder="请输入图片验证码" oninput="value=value.replace(/[\W]/g,'')">
                <template slot="prefix">
                    <i class="el-icon-mobile-phone"/>
                </template>
                <template slot="suffix">
                    <div class="code-img-button" @click="getCode">
                        <img class="login-code-img" :src="codeUrl"/>
                    </div>
                </template>
            </el-input>
        </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button size="large" @click="close">取 消</el-button>
        <el-button size="large" type="primary" @click="submitForm">确 定</el-button>
    </span>
    </el-dialog>
</template>

<script>
import { getCode, checkPicCode} from '@/api/login'
export default {
    name:'verificationCode',
    props:{
        value:{
            type:Boolean,
            default:false
        },
        phone:{
            type:String,
            default:'' 
        }
    },
    data(){
        return{
            codeForm: {
                code:'',
            },
            codeUrl:'',
            codeRules: {
                code: [
                    { required: true, message: '请输入图片验证码', trigger: 'blur' },
                ],
            }
        }
    },
    methods: {
        // 获取验证码
        getCode(){
            getCode().then(res=>{
                this.codeUrl = `data:image/jpeg;base64,${res.data.code}`
                this.codeForm.codeId = res.data.id
            })
        },
        // 校验验证码
        checkPicCode(data){
            return new Promise((resolve,reject)=>{
                checkPicCode(data).then(res=>{
                    resolve(res.data)
                }).catch(err=>{
                    resolve(err.data)
                })
            })
        },
        open(){
            this.getCode()
        },
        close(){
            this.$refs.codeForm.resetFields();
            this.$emit('close');
        },  
        submitForm(){
            this.$refs.codeForm.validate(async (valid) => {
                if (valid) {
                    const obj = {phone:this.phone,...this.codeForm}
                    const data = await this.checkPicCode(obj)
                    if (data.code==109) {
                        this.$toast({
                            type: 'error',
                            message: data.msg,
                            duration: 2000
                        })
                        this.getCode()
                    } else {
                        this.$toast({
                            type: 'success',
                            message: '验证成功！',
                            duration: 2000
                        })
                        this.close()
                    }
                } else {
                    return false;
                }
            }) 
        }
    }
}
</script>

<style lang="scss" scoped>
/deep/ .code-dialog{
    border-radius: 30px;
    .el-form-item{
        margin-bottom: 40px;
        .el-form-item__content{
            .el-input__prefix{
                color: #333333;
                font-size: 18px;
                display: flex;
                align-items: center;
                left: 16px;
                &::after{
                    content:'';
                    display: block;
                    width: 1px;
                    height: 50%;
                    margin-left: 10px;
                    background: #999999;
                }
                .el-input__icon{
                    line-height: 50px;
                }
            }
            .el-input__inner{
                height: 50px;
                font-size: 15px;
                padding-left: 60px;
            }
            .el-input__suffix{
                top:1px
            }
            .code-img-button{
                height: 48px;
                margin-right: -4px;
                border-radius: 0px 4px 4px 0;
                overflow: hidden;
                img{
                    height: 100%;
                }
            }
        }
    }
    .dialog-footer{
        display: flex;
        justify-content: space-around;
    }   
}
</style>